import {
  BACKGROUND_REPLACE_GENERATION_TYPE,
  LORA_GENERATION_TYPE,
  REFRAME_GENERATION_TYPE,
} from "../../../Board/constants.ts";
import {
  getModelDefaultGenerationParams,
  updateModelGenerationParams,
} from "./baseSelectedModelsUtils.ts";
import { selectedModelsStorageFactory } from "./selectedModelsStorageFactory.ts";

export const createWorkspaceSelectedModelsStorage =
  selectedModelsStorageFactory(
    "board-create-workspace-selected-models-generation-params",
    2,
    [
      LORA_GENERATION_TYPE,
      REFRAME_GENERATION_TYPE,
      BACKGROUND_REPLACE_GENERATION_TYPE,
    ],
    getModelDefaultGenerationParams,
    updateModelGenerationParams,
  );
